import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "steps__step-number" }
const _hoisted_2 = { class: "steps__step-title-wrapper" }
const _hoisted_3 = { class: "steps__step-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-8 mb-2" }, " Design team & developer ", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "steps__step-summary"
}
const _hoisted_6 = {
  key: 1,
  class: "steps__step-summary"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-8 mb-2" }, " Partners ", -1 /* HOISTED */)
const _hoisted_12 = {
  key: 2,
  class: "steps__step-summary"
}
const _hoisted_13 = {
  key: 3,
  class: "steps__step-summary"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steps__step", ( $setup.is_completed_step ) ? ' steps__step--completed' : ( $setup.is_current_step ) ? ' steps__step--active' : null])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.step.step_number), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.step.title), 1 /* TEXT */),
      ($setup.is_completed_step)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            ($setup.no_designer_developer_msg === true)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, " No design team or developer selected "))
              : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  ($setup.selected_architects.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                        _createTextVNode(" Architect: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_architects, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_architects.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.selected_landscape_architects.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createTextVNode(" Landscape Architect: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_landscape_architects, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_landscape_architects.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.selected_interior_designers.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                        _createTextVNode(" Interior Designer: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_interior_designers, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_interior_designers.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.selected_developers.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _createTextVNode(" Developer: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_developers, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_developers.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])),
            _hoisted_11,
            ($setup.no_partner_msg === true)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, " No partners selected "))
              : (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  ($setup.selected_creative_agencies.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _createTextVNode(" Creative Agency: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_creative_agencies, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_creative_agencies.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.selected_brand_partners.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                        _createTextVNode(" Brand Partner: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_brand_partners, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_brand_partners.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.selected_sales_marketing_partners.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                        _createTextVNode(" Sales & Marketing Partner: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_sales_marketing_partners, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_sales_marketing_partners.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.selected_hospitality_operators.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                        _createTextVNode(" Hospitality Operator: "),
                        _createElementVNode("span", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected_hospitality_operators, (item, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'key-client-contacts-' + index
                            }, [
                              _createTextVNode(_toDisplayString(item.label + ( index < $setup.selected_hospitality_operators.length - 1 ? ', ' : '' )), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.is_completed_step)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "button button--smaller",
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.setActiveStep( $props.step.step_number )))
        }, " Edit "))
      : ($setup.is_current_step)
        ? (_openBlock(), _createBlock($setup["ExternalTeamFormComponent"], {
            key: 1,
            "step-title": $props.step.title
          }, null, 8 /* PROPS */, ["step-title"]))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}